export default __webpack_public_path__ + "2e8a2eb703b375f8ce977e1f5db87ba0.svg";